// exported function for getting URL of a specific templated page
// based on URL template defined in adlib-config.json file
const templateURL = (data: any, urlTemplate: string) =>
  eval('`/' + urlTemplate + '`')
    .toLowerCase()
    .trim()
    .replace(/ /g, '-') + '/'
export default templateURL
